import React from 'react'
import { Card, Typography, CardContent, CardActions } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Button from 'components/ButtonMaterial'
import { bindActionCreators } from 'redux'
import { removeNotification, fetchNotifications } from 'services/api'
import { showFlashMessageOnUnexpectedError } from 'actions'
import isempty from 'lodash.isempty'
import { connect } from 'react-redux'
import TimeAgo from 'react-timeago'
import * as utils from 'utils'
import Room from '@material-ui/icons/Room'
import { ASSINGMENTS_LOCATION_LABEL } from '../../../constants'

const styles = theme => ({
  link: {
    textDecoration: 'none',
  },
  card: {
    display: 'flex',
    borderRadius: '0px',
    boxShadow: 'none',
    marginBottom: '2%',
    padding: '5px 0 5px 16px',
  },
  cardNoteActive: {
    backgroundColor: '#ebfcfa',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '75%',
  },
  content: {
    flex: '1 0 auto',
    padding: '4% 2%',
    '&:last-child': {
      paddingBottom: '4%',
    },
  },
  notificationContent: {
    color: '#404552',
    marginBottom: '5%',
  },
  button: {
    color: 'black',
    textTransform: 'capitalize',
    minWidth: '90px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  truncate: {
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  propertyPrice: {
    fontSize: '22px',
    fontWeight: '500',
    color: '#333645',
    lineHeight: '0.93',
    paddingBottom: '10px',
  },
  propertySqft: {
    fontSize: '17px',
    fontWeight: 500,
    color: '#00bcb5',
    lineHeight: '0.93',
    paddingBottom: '7px',
  },
  paddingEqul: {
    padding: 5,
  },
  propertyView: {
    display: 'flex',
    alignItems: 'center',
    color: '#838383',
    fontSize: '15px',
  },
  propertyRoom: {
    color: '#fdd200',
    marginLeft: '-5px',
    marginRight: '5px',
  },
  uppercase: {
    textTransform: 'capitalize',
  },
})

class InvestorNotifications extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      notifications: [],
      isRemoving: false,
      notificationFetched: false,
    }
  }

  componentDidMount() {
    this.fetchNotification()
  }

  fetchNotification() {
    fetchNotifications(this.props.user.token).then(response => {
      if (!isempty(response.notifications)) {
        let a = response.notifications
          .filter(obj => obj.property)
          .sort(function(x, y) {
            return new Date(y.displayAt) - new Date(x.displayAt)
          })
          .map(obj => (obj.message = JSON.parse(obj.message)))
        console.log(a)
        this.setState({
          notifications: response.notifications
            .filter(obj => obj.property)
            .sort(function(x, y) {
              return new Date(y.displayAt) - new Date(x.displayAt)
            }),
          notificationFetched: true,
        })
      } else {
        this.setState({
          notificationFetched: true,
        })
      }
    })
  }

  removeNotification = async id => {
    this.setState({
      isRemoving: true,
    })

    try {
      const response = await removeNotification(this.props.user.token, id)

      if (isempty(response.errors)) {
        this.setState(prevState => ({
          notifications: [...prevState.notifications.filter(notification => notification.id !== id)],
        }))
      }
    } catch (error) {
      this.props.showFlashMessageOnUnexpectedError(error)
    }

    this.setState({
      isRemoving: false,
    })
  }

  buildPropertyUrl = id =>
    `${window.location.protocol}//${process.env.REACT_APP_BASE_DOMAINS}${window.location.port ? ':' + window.location.port : ''}/listings/${id}`

  render() {
    const { notifications, notificationFetched } = this.state
    const { classes } = this.props

    return (
      <div>
        {notifications.length > 0
          ? notifications.map(notification => (
              <Card className={!notification.isRead ? `${classes.card} ${classes.cardNoteActive}` : classes.card} key={notification.id}>
                <div className={classes.details}>
                  <a href={`${this.buildPropertyUrl(notification.property.id)}`} className={classes.link}>
                    <CardContent className={classes.content}>
                      {notification.property && (
                        <div>
                          <Typography variant="headline" component="h1" className={`${classes.truncate} ${classes.propertyPrice}`}>
                            {`$${utils.withCommas(notification.property.price || 0)}`}
                          </Typography>
                          <Typography component="p" className={`${classes.truncate} ${classes.propertySqft}`}>
                            {`${utils.withCommas(notification.property.sqft || 0)} SQFT`}
                            <span className={classes.paddingEqul}>&bull;</span>
                            {notification.property.beds || 0} BD
                            <span className={classes.paddingEqul}>&bull;</span>
                            {notification.property.baths || 0} BA
                          </Typography>
                          <Typography className={classes.propertyView} component="p">
                            <Room className={classes.propertyRoom} />{' '}
                            <span className={classes.truncate}>
                              {notification.property.address &&
                              !(notification.property.type && notification.property.type.toLowerCase() === process.env.REACT_APP_ASSINGMENTS_PROPERTY_TYPE)
                                ? `${notification.property.address}, ${notification.property.city}, ${notification.property.state}`
                                : `${ASSINGMENTS_LOCATION_LABEL}`}
                            </span>
                          </Typography>
                        </div>
                      )}
                      <div>
                        <Typography variant="caption" color="textSecondary" className={classes.uppercase}>
                          {notification.message.action === 'new' ? 'Created' : 'Updated'} <TimeAgo date={new Date(notification.displayAt)} />
                        </Typography>
                      </div>
                    </CardContent>
                  </a>
                </div>
                <CardActions>
                  <Button onClick={() => this.removeNotification(notification.id)} link className={classes.button} isLoading={this.state.isRemoving}>
                    Delete
                  </Button>
                </CardActions>
              </Card>
            ))
          : notificationFetched && <Typography>You don't have any notifications at this time.</Typography>}
      </div>
    )
  }
}

InvestorNotifications.propTypes = {
  user: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showFlashMessageOnUnexpectedError }, dispatch)
}

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps
  )(InvestorNotifications)
)



// WEBPACK FOOTER //
// ./src/features/investorDashboard/components/InvestorNotifications.js